import React from 'react'
import Calendar from './Calendar'
import EventListContent from './EventListContent'
import Grid from '@material-ui/core/Grid'
import { Query } from 'react-apollo'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  getTrackableIds
} from '../utils/trackable'
import {
  EVENT_CREATED,
  EVENT_OF_SELECTED_DAY,
  EVENT_TO_CHECK_OF_SELECTED_DAY,
  CHECKED_EVENT_OF_SELECTED_DAY,
  OFFENSE_OF_SELECTED_DAY,
  EVENT_OF_SELECTED_MONTH,
  EVENT_TO_CHECK_OF_SELECTED_MONTH,
  CHECKED_EVENT_OF_SELECTED_MONTH,
  OFFENSE_OF_SELECTED_MONTH,
  REFUEL_EVENT_BY_DATE,
  REFUEL_EVENT_DATE_BY_MONTH
} from '../query/event'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import CircularProgress from '@material-ui/core/CircularProgress'
import { omegaClient } from '../graphql/omegaClient'
moment.locale('fr')

let d = new Date()
d.setHours(0, 0, 0, 0)

class EventContentComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedDay: props.events && props.events.length > 0 ? moment(new Date()).format('YYYY-MM-DD') : undefined,
      data: props.events,
      dateList: [],
      selectedMonth: d,
      loadingEvents: false
    }
  }

  componentDidMount () {
    // Fetch event dates for current month
    const month = this.state.selectedMonth
    const monthNumber = month.getMonth() + 1
    const yearNumber = month.getFullYear()

    if (this.props.sensorIds && this.props.sensorIds.length > 0) {
      this.refuelEventDateByMonth(this.props.sensorIds, monthNumber.toString(), yearNumber.toString())
        .then((eventDates) => {
          const uniqueDateStrings = [...new Set(eventDates.map(eventDate => eventDate.date))]
          const dateList = uniqueDateStrings.map(dateStr => new Date(dateStr))
          this.setState({ dateList })
        })
        .catch((error) => {
          console.log('error fetching month dates', error)
        })
    }
  }

  componentWillReceiveProps (nextProps) {
    // Update data when events prop changes (from polling)
    // But only if we're viewing current day
    let formattedSelectedDay = moment(new Date(this.state.selectedDay)).format('MM/DD/YYYY')
    let formattedCurrentDay = moment(new Date()).format('MM/DD/YYYY')

    if (nextProps.events !== this.props.events && formattedSelectedDay === formattedCurrentDay) {
      this.setState({ data: nextProps.events })
    }

    // Fetch event dates when sensorIds become available
    if (nextProps.sensorIds !== this.props.sensorIds && nextProps.sensorIds && nextProps.sensorIds.length > 0) {
      const month = this.state.selectedMonth
      const monthNumber = month.getMonth() + 1
      const yearNumber = month.getFullYear()

      this.refuelEventDateByMonth(nextProps.sensorIds, monthNumber.toString(), yearNumber.toString())
        .then((eventDates) => {
          const uniqueDateStrings = [...new Set(eventDates.map(eventDate => eventDate.date))]
          const dateList = uniqueDateStrings.map(dateStr => new Date(dateStr))
          this.setState({ dateList })
        })
        .catch((error) => {
          console.log('error fetching month dates', error)
        })
    }
  }

  getTrackableIds () {
    if (this.props.trackables) {
      return getTrackableIds(this.props.trackables)
    }
  }

  // componentDidMount () {
  //   if (this.props.route === 'Event' || this.props.route === 'CheckEvent') {
  //     this.props.subscribeToMore({
  //       document: EVENT_CREATED,
  //       variables: { occurred_at: new Date(), trackable_ids: this.getTrackableIds() },
  //       updateQuery: (prev, { subscriptionData }) => {
  //         if (!subscriptionData.data || subscriptionData.data.events.length === 0) {
  //           return prev
  //         }
  //         const currentEventCreated = subscriptionData.data.events
  //         let events = [
  //           ...currentEventCreated,
  //           ...prev.events
  //         ]
  //         this.setState({
  //           data: events
  //         })
  //         return {
  //           events: events
  //         }
  //       }
  //     })
  //   }
  // }

  getDateInData (data) {
    let dateList = []
    data.forEach(function (element) {
      dateList.push(new Date(momentTimezone.utc(element.occurred_at).tz('Indian/Antananarivo')))
    })
    return dateList
  }

  getFormattedDateList (data) {
    let formattedDateList = []
    if (data) {
      data.forEach(function (element) {
        formattedDateList.push(momentTimezone.utc(element.occurred_at).tz('Indian/Antananarivo').format('MM/DD/YYYY'))
      })
    }
    return this.removeDuplicate(formattedDateList)
  }

  removeDuplicate (array) {
    let unique = {}
    array.forEach(function (i) {
      if (!unique[i]) {
        unique[i] = true
      }
    })
    return Object.keys(unique)
  }

  // handleDayClick (day, { selected }, formattedDateList) {
  //   const self = this
  //   var token = localStorage.getItem('token')
  //   let formattedDate = moment(day).format('MM/DD/YYYY')
  //   getUserInfo(token)
  //     .then(response => response.json())
  //     .then(function (result) {
  //       if (result.error && result.error.code === 401) {
  //         refreshToken(localStorage.getItem('refresh_token'))
  //       }
  //       if (formattedDateList.includes(formattedDate)) {
  //         self.setState(
  //           {
  //             selectedDay: day
  //           }
  //         )
  //       }
  //     })
  //     .catch((error) => {
  //       console.log('error: ', error)
  //     })
  // }

  handleDayClick (day, selected) {
    const self = this
    var token = localStorage.getItem('token')
    let formattedDate = moment(day).format('YYYY-MM-DD')
    let formattedCurrentDay = moment(new Date()).format('MM/DD/YYYY')
    let formattedDayClicked = moment(day).format('MM/DD/YYYY')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (result) {
        if (result.error && result.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        self.setState({ selectedDay: formattedDate })

        // Fetch events for selected day if not current day
        if (formattedDayClicked !== formattedCurrentDay) {
          self.setState({ loadingEvents: true })
          self.refuelEventByDate(self.props.sensorIds, formattedDate)
            .then((refuelEvents) => {
              self.setState({
                data: refuelEvents,
                loadingEvents: false
              })
            })
            .catch((error) => {
              console.log('error', error)
              self.setState({ loadingEvents: false })
            })
        } else {
          // Reset to current day data from props
          self.setState({ data: self.props.events })
        }
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  onMonthChange (month) {
    const self = this
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (result) {
        if (result.error && result.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }

        self.setState({
          selectedMonth: month
        })
        // Fetch event dates for the selected month
        const monthNumber = month.getMonth() + 1 // JavaScript months are 0-indexed
        const yearNumber = month.getFullYear()
        self.refuelEventDateByMonth(self.props.sensorIds, monthNumber.toString(), yearNumber.toString())
          .then((eventDates) => {
            // Get distinct dates and map to Date objects
            const uniqueDateStrings = [...new Set(eventDates.map(eventDate => eventDate.date))]
            const dateList = uniqueDateStrings.map(dateStr => new Date(dateStr))
            self.setState({
              dateList
            })
            // You can store this in state if needed for the calendar
          })
          .catch((error) => {
            console.log('error fetching month dates', error)
          })
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  getEventQueryOfSelectedDay (route) {
    let query
    switch (route) {
      case 'Event':
        query = EVENT_OF_SELECTED_DAY
        break
      case 'CheckEvent':
        query = EVENT_TO_CHECK_OF_SELECTED_DAY
        break
      case 'CheckedEvent':
        query = CHECKED_EVENT_OF_SELECTED_DAY
        break
      case 'Offense':
        query = OFFENSE_OF_SELECTED_DAY
        break
      default:
        query = EVENT_OF_SELECTED_DAY
    }
    return query
  }

  refuelEventByDate (trackableLabels, date) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: REFUEL_EVENT_BY_DATE,
          variables: { trackable_labels: trackableLabels, date: date },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.refuel_events_by_date)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  refuelEventDateByMonth (trackableLabels, month, year) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: REFUEL_EVENT_DATE_BY_MONTH,
          variables: { trackable_labels: trackableLabels, month: month, year: year },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.refuel_events_dates_by_month)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  renderEventListContent () {
    if (this.state.loadingEvents) {
      return <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
    }
    return (
      <EventListContent
        route={this.props.route}
        data={this.state.data}
        keySearch={this.props.keySearch}
        trackables={this.props.trackables}
      />
    )
  }

  getEventQueryOfSelectedMonth (route) {
    let query
    switch (route) {
      case 'Event':
        query = EVENT_OF_SELECTED_MONTH
        break
      case 'CheckEvent':
        query = EVENT_TO_CHECK_OF_SELECTED_MONTH
        break
      case 'CheckedEvent':
        query = CHECKED_EVENT_OF_SELECTED_MONTH
        break
      case 'Offense':
        query = OFFENSE_OF_SELECTED_MONTH
        break
      default:
        query = EVENT_OF_SELECTED_MONTH
    }
    return query
  }

  render () {
    var month = this.state.selectedMonth
    var startMonth = moment([month.getFullYear(), month.getMonth()]).toDate()
    var endMonth = moment([month.getFullYear(), month.getMonth()]).endOf('month').toDate()
    const self = this
    if (['CheckEvent', 'CheckedEvent', 'Offense'].includes(this.props.route)) {
      return null
    }
    // Convert selectedDay string to Date object for react-day-picker
    const selectedDayAsDate = this.state.selectedDay ? new Date(this.state.selectedDay) : undefined
    return (
      <div style={styles.root}>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={12} md={8} lg={9} xl={10}>
            {self.renderEventListContent()}
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={3} xl={2}>
            <Calendar
              initialMonth={this.state.selectedMonth}
              onMonthChange={(month) => this.onMonthChange(month)}
              selectedDay={selectedDayAsDate}
              handleDayClick={(day, selected) => this.handleDayClick(day, selected)}
              dateList={this.state.dateList}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

const styles = {
  root: {
    flexGrow: 1,
    marginLeft: '14px',
    marginBottom: '20px'
  }
}

export default EventContentComponent
